<form [formGroup]="formGroup">
  <div class="d-flex flex-column">
    <div class="field-container">
      <h3> {{'createProposal.internationalProgramQuestion'|translate}}</h3>
    </div>

    <div class="field-container">
      <mat-slide-toggle formControlName="localPoliciesNeeded" class="slider"
                        labelPosition="before">{{'createProposal.localPoliciesNeeded'|translate}}</mat-slide-toggle>
    </div>
    <app-input-field [label]="'createProposal.countryWithLocalPolicies'|translate"
                     [control]="formGroup.controls.countryCodes"
                     *ngIf="formGroup.controls.localPoliciesNeeded.value"
                     class="d-flex field-container">

      <mat-select formControlName="countryCodes"
                  class="input"
                  [value]="formGroup.controls.countryCodes" [multiple]="true" #multiSelect>
        <mat-option>
          <ngx-mat-select-search
            [formControl]="filterCtrlCountry" ngDefaultControl></ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let option of filteredOptionsCountry |async"
                    [value]="option">
          {{option}}
        </mat-option>

      </mat-select>
    </app-input-field>


  </div>
</form>
